import moment from 'moment'

// if dateTime is undefined moment returns the DateTime Now
const timeOnDateFormat = (dateTime) => {
  if (dateTime !== undefined) {
    return `${moment.utc(dateTime).local().format('HH:mm')} on ${moment.utc(dateTime).local().format('DD/MM/YYYY')}`
  }
  return null
}

export default timeOnDateFormat



// WEBPACK FOOTER //
// ./src/utils/formatDateTime.js